import { getConnectionApi } from "../configs/connection-config";
import { CONNECTION } from "../models/common/common";
import { BC_Api_Create_Update_Member_Request, BC_Api_Create_Update_Member_Response, BC_Api_Get_Member_Response } from "../models/customer";
import { CouponQuotaResponse } from "../models/dto/coupon_quota";
import { BC_Api_Get_Line_Coupon_Entry_Response } from "../models/dto/entry";
import { BC_Api_Otp_Check_Quota_Insert_Usage_Request, BC_Api_Otp_Check_Quota_Insert_Usage_Response } from "../models/dto/otp";
import { BC_Api_Redeem_Point_Request, BC_Api_Redeem_Point_Response } from "../models/dto/redeem";
import { BC_Api_Member_Regis_Model_Request, BC_Api_Member_Regis_Model_Response } from "../models/dto/register";
import { encodeURI } from "../utils/function-utils";
import { apiFetch } from "./api-config";

type RequestInitCustom<TBody> = {
    body?: TBody, 
    params?: string, 
    query?: string
}

export const check_regis_permission = async (request: RequestInitCustom<BC_Api_Member_Regis_Model_Request>) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Member_Regis", CONNECTION.BC); 
        const response = await apiFetch({ 
            url: url, 
            method: "POST", 
            body: JSON.stringify(request.body), 
            params: request.params,
            query: request.query,
            headers: headers 
        })
        
        return response as BC_Api_Member_Regis_Model_Response
    }catch (error) {
        throw error;
    }
}

export const redeem_point = async ( request : RequestInitCustom<BC_Api_Redeem_Point_Request>) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Redeem_Point", CONNECTION.BC);
        const response = await apiFetch({ 
            url: url,
            method: "POST", 
            body: JSON.stringify(request.body), 
            params: request.params,
            query: request.query,
            headers: headers 
        })
        
        return response as BC_Api_Redeem_Point_Response;
    }catch (error) {
        throw error;
    }
}

export const get_member_information = async (request: { mobile: string, club?: string, accountNo?: string, lineId?: string }) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Get_Member", CONNECTION.BC);
        let clubCode = "";
        let accountNo = "";
        let line_id = "";
        
        if (request.club) {
            clubCode = ` and memberClub eq '${encodeURI(request.club)}'`;
        }

        if (request.accountNo) {
            accountNo = ` and memberAccountNo eq '${request.accountNo}'`;
        }

        if (request.lineId) {
            line_id = ` and lineUserId eq '${request.lineId}'`;
        }
        const query = `$filter=mobileNo eq '${request.mobile}'` + clubCode + accountNo + line_id;
        const response = await apiFetch({ 
            url: url,
            method: "GET", 
            query: query,
            headers: headers 
        })

        return response.value[0] as BC_Api_Get_Member_Response
        
    } catch (error) {
        throw error;
    }
}


export const create_update_member = async (request: BC_Api_Create_Update_Member_Request) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Create_Update_Member", CONNECTION.BC);

        const response = await apiFetch({ 
            url: url,
            method: "POST", 
            body: JSON.stringify(request),
            headers: headers 
        })

        return response as BC_Api_Create_Update_Member_Response;
        
    } catch (error) {
        throw error;
    }
}


export const insert_log_otp = async (request: { body: BC_Api_Otp_Check_Quota_Insert_Usage_Request} ) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Otp_Check_Quota_Insert_Usage", CONNECTION.BC);
        const response = await apiFetch({ 
            url: url,
            method: "POST", 
            body: JSON.stringify(request.body), 
            headers: headers 
        });

        return response as BC_Api_Otp_Check_Quota_Insert_Usage_Response

    } catch (error) {
        throw error;
    }
}

export const get_coupon_entry = async (request: { club: string, accountNo: string}) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_Get_His_Coup", CONNECTION.BC);
        const query = `$filter=memberClub eq '${encodeURI(request.club)}' and memberAccNo eq '${request.accountNo}'`;
        const response = await apiFetch({ 
            url: url,
            method: "GET", 
            headers: headers, 
            query: query,
        });

        return response.value as BC_Api_Get_Line_Coupon_Entry_Response[];

    } catch (error) {
        throw error;
    }
}

export const check_coupon_quota = async (request: { couponCode: string, accountNo: string }) => {
    try {
        const [ url, headers ] = getConnectionApi("BC_Api_CheckQuota_Coupon", CONNECTION.BC);
        // const query = `$filter=couponCode eq '${request.couponCode}' and memberAccountNo eq '${request.accountNo}'`;
        const response = await apiFetch({ 
            url: url,
            method: "POST", 
            headers: headers,
            body: JSON.stringify({
                couponCode: request.couponCode,
                memberAccountNo: request.accountNo
            })
        });

        return response as CouponQuotaResponse;

    } catch (error) {
        throw error;
    }
}

export const getDownLoadFile = async (url: string) => {
    try {
        const response = await fetch(url);
        return response
    } catch (error) {
        throw error;
    }
}
